export const paths = {
  accessPage: "/",
  presale: "/presale",
  debug: "/debug",
  development: "/development",
  admin: "/3EXAxEXz3QTDc6KpUoJneVEbmFfnhsb72rR",
  notFound: "/*"
};
